'use client';

import { c as _c } from "react/compiler-runtime";
import { useToast } from '@7f-ui/components/toast/toast-provider';
import { CartCountDocument, CartDocument } from '@data-access/lib/gql/cart/documents';
import { GuestDataDocument } from '@data-access/lib/gql/profile/documents';
import { getGraphqlQueryKey } from '@data-access/lib/graphql-query';
import { useQueryClient } from '@tanstack/react-query';
import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, useEffectEvent, useRef } from 'react';
import { useAppSession } from 'src/lib/auth/client/app-session-provider';
import { AUTH_TOAST_QUERY_PARAM, getAuthToastMessage, removeAuthToast } from 'src/lib/auth/paths';
export function AppAuthToastQueryHandler() {
  const $ = _c(21);
  const pathname = usePathname() ?? "/";
  const queryClient = useQueryClient();
  const searchParams = useSearchParams();
  const toast = useToast();
  const {
    refresh
  } = useAppSession();
  const handledToastKeyRef = useRef(null);
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams?.get(AUTH_TOAST_QUERY_PARAM) ?? null;
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const authToast = t0;
  let t1;
  if ($[2] !== searchParams) {
    t1 = searchParams?.toString() ?? "";
    $[2] = searchParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const search = t1;
  const t2 = `${pathname}${search ? `?${search}` : ""}`;
  let t3;
  if ($[4] !== t2) {
    t3 = removeAuthToast(t2);
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const cleanedPath = t3;
  let t4;
  if ($[6] !== queryClient || $[7] !== refresh || $[8] !== toast) {
    t4 = currentAuthToast => {
      const message = getAuthToastMessage(currentAuthToast);
      if (!message) {
        return;
      }
      toast({
        type: "success",
        message
      });
      if (currentAuthToast === "login-success" || currentAuthToast === "register-success") {
        refresh();
        return;
      }
      if (currentAuthToast === "account-deleted") {
        queryClient.removeQueries({
          queryKey: getGraphqlQueryKey(CartDocument)
        });
        queryClient.removeQueries({
          queryKey: getGraphqlQueryKey(CartCountDocument)
        });
        queryClient.removeQueries({
          queryKey: getGraphqlQueryKey(GuestDataDocument)
        });
        refresh();
      }
    };
    $[6] = queryClient;
    $[7] = refresh;
    $[8] = toast;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleAuthToast = useEffectEvent(t4);
  let t5;
  if ($[10] !== authToast || $[11] !== cleanedPath || $[12] !== handleAuthToast || $[13] !== pathname || $[14] !== search) {
    t5 = () => {
      if (!authToast) {
        handledToastKeyRef.current = null;
        return;
      }
      const toastKey = `${pathname}?${search}`;
      if (handledToastKeyRef.current === toastKey) {
        return;
      }
      handledToastKeyRef.current = toastKey;
      window.history.replaceState(window.history.state, "", cleanedPath);
      handleAuthToast(authToast);
    };
    $[10] = authToast;
    $[11] = cleanedPath;
    $[12] = handleAuthToast;
    $[13] = pathname;
    $[14] = search;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== authToast || $[17] !== cleanedPath || $[18] !== pathname || $[19] !== search) {
    t6 = [authToast, cleanedPath, pathname, search];
    $[16] = authToast;
    $[17] = cleanedPath;
    $[18] = pathname;
    $[19] = search;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  useEffect(t5, t6);
  return null;
}